import { yup } from '@framework/validation';
import { ApplicantDataTypes } from './ApplicantDataTypes';
import { CompanyApplicantDataTypes } from './CompanyApplicantData';

export interface IApplicantDataDirective {
  /**
   * Codice dell'attributo del titolare, es. "fiscalNumber"
   */
  code?: string | null;
}

export const ApplicantDataDirectiveSchema: yup.ObjectSchema<IApplicantDataDirective> =
  yup
    .object({
      code: yup
        .string()
        .oneOf(
          [...ApplicantDataTypes.Codes, ...CompanyApplicantDataTypes.Codes],
          `L'attributo indicato non è valido`,
        )
        .required()
        .label('Attributo del titolare'),
    })
    .noUnknown();
